/**
 * Package Service
 *
 * API service for fetching package/plan data and usage limits
 */

import apiClient from './api';
import { TeamPackageResponse } from '@/types/package';

export const packageService = {
  /**
   * Get current team's package and usage
   */
  async getTeamPackage(): Promise<TeamPackageResponse | null> {
    const response = await apiClient.get('/api/teams/package');
    return response.data.data ?? null;
  },
};
